import { breakpoint, colors, fontFamily, fontSize, mediaQueryHelper } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  hiringContainer: css({
    backgroundColor: '#243E6D',
    color: colors.white,
    fontFamily: fontFamily.heading,
    padding: '40px 24px',
    overflow: 'hidden',

    [mediaQueryHelper(breakpoint.desktop)]: {
      padding: '100px 40px',
    },
  }),

  headerText: css({
    textAlign: 'left',

    [mediaQueryHelper(breakpoint.phone)]: {
      textAlign: 'center',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      textAlign: 'center',
    },
  }),

  title: css({
    fontSize: fontSize.large,
    lineHeight: '140%',
    marginBottom: '18px',

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: '2rem',
    },
  }),

  subText: css({
    fontSize: fontSize.medium,
    lineHeight: '140%',
  }),

  cardContainer: css({
    display: 'grid',
    maxWidth: '500px',
    margin: 'auto',
    gridColumnGap: '60px',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
    textAlign: 'left',

    [mediaQueryHelper(breakpoint.tablet)]: {
      gridTemplateColumns: '1fr 1fr 1fr',
      maxWidth: '1050px',
      margin: '40px auto 0',
    },
  }),

  cardBlock: css({
    textAlign: 'left',
    borderBottom: `2px dashed ${colors.cornflowerBlue}`,
    padding: '15px 0',

    h3: {
      marginBottom: '24px',
      lineHeight: '130%',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      textAlign: 'center',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      textAlign: 'left',
      borderBottom: 'none',
    },
  }),

  imageContainer: css({
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    position: 'relative',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 'auto',
      maxWidth: '300px',
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      maxWidth: '100%',
    },
  }),

  noBorder: css({
    borderBottom: 'none',
  }),

  cardImage: css({
    maxWidth: '300px',
    width: '100%',
    display: 'block',
  }),

  cardText: css({
    margin: '0px',
    fontSize: '15px',
    lineHeight: '150%',
    marginBottom: '15px',
  }),

  cardIcon: css({
    display: 'inline-block',
    margin: '0 5px -3px 0',
    width: '16px',
    height: '16px',
  }),
}

export default styles
